﻿/**
Copyright [2022] [https://www.merac.com
 */
const runtimeApiBaseUrl = import.meta.env.DEV ? '' : import.meta.env.VITE_API_BASEURL
export const API_PREFIX = '/api'
export const resolveApiUrl = (path = '', baseUrl = runtimeApiBaseUrl) => {
	if (/^https?:\/\//.test(path)) return path
	const base = (baseUrl || API_PREFIX).replace(/\/+$/, '')
	return `${base}${path.startsWith('/') ? path : `/${path}`}`
}

const DEFAULT_CONFIG = {
	// 棣栭〉鍦板潃
	DASHBOARD_URL: '/index',

	// 鎺ュ彛鍦板潃
	API_URL: runtimeApiBaseUrl,
	API_PREFIX,

	// 璇锋眰瓒呮椂
	TIMEOUT: 60000,

	// TokenName // Authorization
	TOKEN_NAME: 'token',

	// Token鍓嶇紑锛屾敞鎰忔渶鍚庢湁涓┖鏍硷紝濡備笉闇€瑕侀渶璁剧疆绌哄瓧绗︿覆 // Bearer
	TOKEN_PREFIX: '',

	// 杩藉姞鍏朵粬澶?
	HEADERS: {},

	// 璇锋眰鏄惁寮€鍚紦瀛?
	REQUEST_CACHE: false,

	// 甯冨眬 缁忓吀锛歝lassical锛屽弻鎺掕彍鍗曪細doublerow
	DIGIT_LAYOUT: 'doublerow',

	// 鑿滃崟鏄惁鎶樺彔
	DIGIT_MENU_COLLAPSE: false,

	// 妯″潡鍧?
	DIGIT_MODULE_UNFOLD_OPEN: true,

	// 鏄惁寮€鍚鏍囩
	DIGIT_LAYOUT_TAGS_OPEN: true,

	// 鏄惁寮€鍚睍绀洪潰鍖呭睉
	DIGIT_BREADCRUMD_OPEN: false,

	// 椤舵爮鏄惁搴旂敤涓婚鑹?
	DIGIT_TOP_HANDER_THEME_COLOR_OPEN: false,

	// 椤舵爮涓婚鑹查€氭爮
	DIGIT_TOP_HANDER_THEME_COLOR_SPREAD: false,

	// 渚ц竟鑿滃崟鏄惁鎺掍粬灞曞紑
	DIGIT_SIDE_UNIQUE_OPEN: true,

	// 璇█
	LANG: 'zh-cn',

	// 涓婚棰滆壊
	COLOR: '#1890FF',

	// 榛樿鏁翠綋涓婚
	DIGIT_THEME: 'dark',

	// 鏁翠綋琛ㄥ崟椋庢牸
	DIGIT_FORM_STYLE: 'drawer',

	// 鎴愬姛鑹?
	success: '#52c41a',

	// 璀﹀憡鑹?
	warning: '#faad14',

	// 閿欒鑹?
	error: '#f5222f',

	// 绯荤粺鍩虹閰嶇疆锛岃繖浜涙槸鏁版嵁搴撲腑淇濆瓨璧锋潵鐨?
	SYS_BASE_CONFIG: {
		// 榛樿logo
		DIGIT_SYS_LOGO: '/img/logo.png',
		// 鍚庣鎺ュ彛鍦板潃
		DIGIT_SYS_API_URL: runtimeApiBaseUrl,
		// 绯荤粺鍚嶇О
		DIGIT_SYS_NAME: 'MERAC_STORE_FRONT',
		// 鐗堟湰
		DIGIT_SYS_VERSION: '2.0',
		// 鐗堟潈
		DIGIT_SYS_COPYRIGHT: 'Copyright [2022] [https://www.merac.com',
		// 鐗堟潈璺宠浆URL
		DIGIT_SYS_COPYRIGHT_URL: 'https://www.merac.com',
		// 榛樿鏂囦欢瀛樺偍
		DIGIT_SYS_DEFAULT_FILE_ENGINE: 'LOCAL',
		// 鏄惁寮€鍚獙璇佺爜
		DIGIT_SYS_DEFAULT_CAPTCHA_OPEN: 'false',
		// 榛樿閲嶇疆瀵嗙爜
		DIGIT_SYS_DEFAULT_PASSWORD: '123456'
	}
}

export default DEFAULT_CONFIG

